import script from "./openAccount.vue?vue&type=script&lang=ts&setup=true"
export * from "./openAccount.vue?vue&type=script&lang=ts&setup=true"

import "./openAccount.vue?vue&type=style&index=0&id=cfe668a0&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/open_acc_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfe668a0"]])

export default __exports__